import { UserContactInfo } from 'src/State/User/UserModel'
import { UserContactInfoDto } from '../api/dto/user.dto'

const fromContactInfoDtoToModel = (value: UserContactInfoDto): UserContactInfo => ({
  username: value.Username || '',
  firstName: value.Vorname || '',
  lastName: value.Name || '',
  email: value.Email || '',
  phone: value.Telefon || '',
})

export default fromContactInfoDtoToModel
